import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["textarea"];

  connect() {
    const params = new URLSearchParams(window.location.search);
    if (params.has("message")) {
      requestAnimationFrame(() => {
        this.textareaTarget.scrollIntoView({ behavior: "smooth", block: "center" });
        this.textareaTarget.focus();
      });
    }
  }
}
